/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-12-15",
    versionChannel: "nightly",
    buildDate: "2024-12-15T00:07:14.607Z",
    commitHash: "23837a48093d10fb54a0bb4c22a76cfa52b38318",
};
